<template>
  <!--<a href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect">点击登录</a>-->
  <!--<a href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn/xstWxUser/getUserInfo&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect">点击登录</a>-->
  <!--<a href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx08fea33c7b97e40b&redirect_uri=http://q2pegt.natappfree.cc/xstWxUser/getUserInfo&response_type=code&scope=snsapi_userinfo#wechat_redirect">点击登录</a>-->

  <div>
    <div class="w-all w-minw bd-sd-b hg-40 bg-c-ffffff">
      <div class="w-main m-auto">
        <div class="fr">
          <div class="hover-ucenter fl">
            <div class="top_ucenter fl fs-12 line-h40"></div>
          </div>

          <a
            class="fs-12 ftc-000000 line-h40 go-login more"
            href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=https://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
          >
            <i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>
            {{username}}
          </a>

         

          <span class="fs-12 ftc-000000 line-h40 m-l-15">|</span>

          <div class="fr m-l-15">
            <div class="my-lesson">
              <a
                href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=https://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
                class="fl fs-12 ftc-000000 line-h40"
              >
                <i class="iconfont icon-play1 m-r-4"></i>作品列表
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>

    <div class="toppic wall mb10">
      <div class="picself wall">
        <ul>
          <li>
            <a href="/Login">首页</a>
          </li>
          <!-- <li>
            <a href="/Login">活动启事</a>
          </li>-->
          <li>
            <a href="/cgzp">课改成果展评</a>
          </li>
          <li>
            <a href="/lwzp">原创成果展评</a>
          </li>
          <li>
            <a
            class="fs-12 ftc-000000 line-h40 go-login more"
            href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=http://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
          >上传作品</a>
          </li>
          <li>
            <a href="/hjcx">获奖查询</a>
          </li>


          <li>
            <a href="https://open.weixin.qq.com/connect/qrconnect?appid=wx21ff014f5ae9fbbb&redirect_uri=https://xspx.zhyww.cn&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect">
            <img width="150px" src="../assets/images/bmcj.png" />
            </a>
          </li>
          <!-- <li>
            <el-dropdown class="wqhg">
              <span
                class="el-dropdown-link"
                style="color: #fff;font-size: 18px; font-weight: bold;"
              >
                往期回顾
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <a href="https://mp.weixin.qq.com/s/QHvIj77doCK5F8lV0i0bcA" target="_blank">首届课改成果</a>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a href="https://mp.weixin.qq.com/s/ht_BMbprHpfQowc-mpua7w" target="_blank">首届原创论文</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li> -->
        </ul>
        <!-- <a class="uploadfile" @click="tojiesu">上传作品</a> -->
      </div>
    </div>
    <div class="main mb10">
      <div class="w1200">
        
        <div class="f14 of bg" style="margin-top:50px; text-indent:2em;display: flex;">
          <div style="width:60%">
            <div >
              <img id="hddy" src="../assets/images/hddy.png" />
            </div>
            <div >
              <p>
              教育兴则国家兴，教育强则国家强。为了助力国家教育振兴，加强语文教育培基铸魂作用，表彰学科学术研究探索，鼓舞砥砺前行的语文人，《语文报》社联合中国语文报刊协会、中国知网等社会各方力量，已连续五届成功举办新时代语文教育学术展评活动，取得有目共睹的成果。秉持初心，笃行致远，《语文报》社自2026年3月始，正式开启第六届新时代语文教育学术展评活动。
              </p>
              <p>
　　              活动起讫时间：2026年3月20日—11月30日。
              </p>
            </div>
          </div>
           
          <div>
             <img width="400px" src="../assets/images/jiangpai.png" />
          </div>

        </div>
       
     

        <div style="height:560px">
          <div class="f14 of bg"  style="background-color:#fff">
            <div  >
              <img id="dszwh" src="../assets/images/dszwh.png"  style="margin-left:30px"/>
            </div>
            <div class="w1200">
              <p  style="margin-left:30px;margin-top:10px">
                <b>
                <span class="mr1">主</span>任：
                </b>
                <span class="mr35">
                  <span class="mr1"></span>姜联众（语文报社社长）
                </span> 顾之川（人民教育出版社编审）
                <br />
                <b>副主任：</b>
             
                <span style="margin-left:15px;"><span style="margin-right: .2em"></span>李华平（四川师范大学教授）</span>
                <br />
                <b>专家组成员（按姓氏音序排列）：</b>
                <span class="mr35">
                  <span class="mr1">陈</span>军
                </span>
                <span class="mr35">程少堂</span>
                <span class="mr35">
                  <span class="mr1">程</span>翔
                </span>
                <span class="mr35">段承校</span>
                <span class="mr35">何立新</span>
                <span class="mr35">季科平</span>
                <br />

                <span class="mr35" style="margin-left:210px">
                  <span class="mr1">贾</span>玲
                </span>
                <span class="mr35">李明新</span>
                <span class="mr35">
                  <span class="mr1">吴</span>伟
                </span>
                <span class="mr35">武宏钧</span>
                <span class="mr35">
                  <span class="mr1">杨</span>桦
                </span>
                <span class="mr35"><span style="margin-right: -.4em"></span>余映潮</span>
                <br />

                <span class="mr35" style="margin-left:210px">张春莲</span>
                <span class="mr35"><span style="margin-right: .3em"></span>张玉新</span>
                <span class="mr35">张云鹰</span>
                <span class="mr35"><span style="margin-right: .3em"></span>章新其</span>
                <span class="mr35">赵福楼</span>
                <span class="mr35">周一贯</span>
                <br />
                <b>评委会秘书处</b>
                <br />
                <b>秘书长：</b> 贾文浒
                <br />
                <b>副秘书长：</b> 王海燕
                <br />
                <b>秘书组：</b>
                <span class="mr35">成向阳</span>
                <span class="mr35">张红安</span> 刘惠榕
                <br />
                <b>活动联系方式：</b>
                <br />
                <b>联系人：</b> 刘老师
                <br />
                <b>联系电话：</b>
                <span class="mr35">0351-6378029</span>
                <br />
                <b>在线咨询：</b> 446102290（QQ）
                <br />
                <b>电子信箱：</b> 446102290@qq.com
                <br />
              </p>
            </div>
          </div>
        </div>
     
         
        <div style="margin-top:50px">
           <img src="../assets/images/bmlc.png"  />
        </div>
        <div class="f14 of bg"  style="margin-top:50px">
          <img src="../assets/images/hdlc.png"  />
        </div>
       
        <br><br><br>
          <div >
              <img src="../assets/images/cgzp.png"  />
              <a href="cgzp" hover="hand">
               <img src="../assets/images/gdxq1.png"   style="position:absolute;margin-top:-80px;margin-left:950px">
               </a>
          </div>
           <br><br><br>
          <div >
              <img src="../assets/images/yczgzp.png"  />
               <a href="lwzp" hover="hand">
               <img src="../assets/images/lwzp.png"   style="position:absolute;margin-top:-80px;margin-left:950px">
               </a>
          </div>
          <div >
             <br><br><br>
              <img src="../assets/images/msgzs.png"  />
               <a href="lwzp" hover="hand">
               <img src="../assets/images/msgz.png"   style="position:absolute;margin-top:-80px;margin-left:950px">
               </a>
          </div>
        <!-- <div >
          <div class="bg1 fl" style="width:550px;margin:10px;">
            <div style="position:absolute">
              <img src="../assets/images/x_jian_y.png" class="x_jian" />
            </div>
            <p class="f16" style="color:#028d7e; padding:30px 30px;">如果您在语文教育领域已有公开的课改成果，欢迎您参加——</p>
            <div class="titlezp mb30">
              <img id="cgzp" src="../assets/images/title_cgzp.png" />
            </div>
            <p class="f14 of" style="padding:30px 45px;margin-bottom:27px">
              <b>一、征稿对象</b>
              <br />面向所有小学、中学、大学的语文教学教研工作者。
              <br />
              <b>二、征稿说明</b>
              <br />1.参评学术成果应符合新时代课改精神。
              <br />2.参评学术成果包括论文、专著(含编著)、课题、获奖公开课等。
              <br />3.参评学术成果必须与语文教育有关，可以体现在课标研究、教材研究、教法探讨、教学设计、课堂展示、课外拓展、教学反思、考试评价等语文教学与研究的各个环节。
              <br />参评要求、参评办法和评奖程序等详见活动启事。
              <br />
            
            </p>
            <div class="mb30" style="width:321px;margin:15px auto 0;">
              <a href="cgzp" hover="hand">
                <img id="detail_y" src="../assets/images/detail_y.png" />
              </a>
            </div>
          </div>

          <div class="bg1 fl" style="width:550px;margin:10px;">
            <div style="position:absolute">
              <img src="../assets/images/x_jian_b.png" class="x_jian" style="top:-53px;" />
            </div>
            <p class="f16" style="color:#028d7e; padding:30px 30px;">如果您在语文教育领域有未公开的原创成果，欢迎您参加——</p>
            <div class="titlezp mb30">
              <img id="lwzp" src="../assets/images/title_lwzp.png" />
            </div>
            <p class="f14 of" style="padding:30px 45px;">
              <b>一、征稿对象</b>
              <br />1.面向所有小学、中学语文教师和语文教研员；2.高校语文学科及语文教育专业的教师、学生；3.中职院校语文教师；4.语文教育报刊编辑。5、“跨学科学习”专题征文同时面向其他学科老师。
              <br />
              <b>二、征稿说明</b>
              <br />1.参评作品为未正式发表的教学论文、教学设计、教学随笔、创意写作文章等。
              <br />2.来稿可自择角度，自拟题目；倡导学术性与实践性并重，内容切实具体，文风扎实严谨；知网查重须在20%以内。
              <br />3.参评作品必须保证是本人原创，不得抄袭他人成果、侵犯他人版权。
             
              <br />
            </p>
            <div class="mb30" style="width:321px;margin:0 auto;">
              <a href="lwzp" hover="hand">
                <img id="detail_b" src="../assets/images/detail_b.png" />
              </a>
            </div>
          </div>
        </div> -->

        <div class="blank mb25"></div>
        <!-- <div style="position:absolute">
          <img src="../assets/images/jian_y.png" class="jian" style="top:25px;" />
        </div> -->
        <!-- <div style="margin-left: -20px">
          <img id="liucheng" src="../assets/images/liucheng.png" />
        </div> -->
      </div>
      <br> <br> <br>
    </div>
    <div
      class="footer"
      style="background:url(('../../assets/images/foot.png')) top center no-repeat;"
    >
      <div class="menu">
        <div class="box">
          <a href="http://www.zhyww.cn/ywbs/bsjj/202006/115472.html" target="_blank">关于我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115483.html"
            target="_blank"
          >联系我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115484.html"
            target="_blank"
          >版权声明</a>
        </div>

        <div class="copyright">
          <p>语文网版权所有 未经书面授权 不得复制或建立镜像 晋公网安备14010902000073号</p>
          <p>
            增值电信业务经营许可证晋B2-20030007 新出网许（晋）字005号
            <a
              href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
              target="_blank"
            >晋ICP备09011058号</a>
            <a
              href="http://webscan.360.cn/index/checkwebsite/url/www.zhyww.cn"
              name="f7c1c8d71288f01cb16d63638e8f82bc"
            >网站安全检测平台</a>
          </p>
        </div>

        <a href="http://webscan.qianxin.com/safe/detail/?query=www.zhyww.cn">
          <img
            border="0"
            src="http://webscan.qianxin.com/api/authcode?code=fd753cb81c61b4824c3645292d170f85"
            style="display: none;"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/base.css";
import "@/assets/xspx.css";
import { GetUserInfo } from "@/request/api";
export default {
  data() {
    return {
      username: "您好，请登录"
    };
  },
  created() {},
  methods: {
    getUsersInfo() {
      let _this = this;
      var code = this.$route.query.code;
      console.log("code:", code);
      if (typeof code == "undefined") {
        console.log("code2:", code);
      } else {
        console.log("code1:", code);
        GetUserInfo({ code: code }).then(
          function(resp) {
            console.log(resp);
            console.log(resp.data);
            var openid = resp.data;
            if (openid != "") {
              sessionStorage.setItem("openid", openid);
              console.log("成功");
              _this.$router.push({ path: "/Show" });
            } else {
              alert("请重新登录");
              _this.$router.push({ path: "/" });
            }
          },
          function(err) {
            console.log("失败");
          }
        );
      }
    },
    tojiesu() {
      alert("活动已结束");
    }
  },
  mounted() {
    //这个属性就可以，在里面声明初始化时要调用的方法即可
    // we can implement any method here like
    this.getUsersInfo();
  }
};
</script>
